import { LessonsTable } from "./lessons-table";

/** "Dersler" tab of a tutor (permission `lessons.view`). */
export function TutorLessonsTab({ tutorId }: { tutorId: string }) {
  return (
    <LessonsTable
      endpoint={`/api/office/tutors/${tutorId}/lessons`}
      showTutor={false}
      showStudent
    />
  );
}
